module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "container_right_hotrecommend"
  }, [_c('div', {
    staticClass: "container_right_hotrecommend_icon"
  }, [_vm._v("剧组动态")]), _vm._v(" "), _c('div', {
    staticClass: "container_right_hotrecommend_img",
    on: {
      "click": function($event) {
        return _vm.imgClickFun()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgTargeturl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_right_hotrecommend_font"
  }, [_c('ul', [_vm._l((_vm.newsListDataArr), function(item, index) {
    return [_c('li', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CmsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name:'CmsDetail',query:{id:item.id}}"
      }],
      key: index
    }, [_vm._v(_vm._s(item.title))])]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4323cc10","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CmsCrew.vue
// module id = 1217
// module chunks = 0